interface EmailConfig {
  who: string;
  where: string;
  subj: string;
  link: string;
}

const officers: Map<string, EmailConfig> = new Map<string, EmailConfig>([
  [
    "president",
    {
      who: "president",
      where: "richmondwoodturners.org",
      subj: "A Richmond Woodturners Presidential Matter",
      link: "President",
    },
  ],
  [
    "vp",
    {
      who: "vp",
      where: "richmondwoodturners.org",
      subj: "A Matter for the Vice President of Richmond Woodturners",
      link: "Vice President",
    },
  ],
  [
    "treasurer",
    {
      who: "treasurer",
      where: "richmondwoodturners.org",
      subj: "A Matter for the Richmond Woodturners Treasurer",
      link: "Treasurer",
    },
  ],
  [
    "secretary",
    {
      who: "secretary",
      where: "richmondwoodturners.org",
      subj: "A Richmond Woodturners Secretarial Matter",
      link: "Secretary",
    },
  ],
  [
    "activities",
    {
      who: "activities",
      where: "richmondwoodturners.org",
      subj: "A Matter for the Activities Director of Richmond Woodturners",
      link: "Activities Director",
    },
  ],
  [
    "av",
    {
      who: "av",
      where: "richmondwoodturners.org",
      subj: "Richmond Woodturners A-V",
      link: "A/V Director",
    },
  ],
  [
    "information",
    {
      who: "information",
      where: "richmondwoodturners.org",
      subj: "Information About Richmond Woodturners",
      link: "Information Director",
    },
  ],
  [
    "membership",
    {
      who: "membership",
      where: "richmondwoodturners.org",
      subj: "Richmond Woodturners Membership",
      link: "Membership Director",
    },
  ],
  [
    "newsletter",
    {
      who: "newsletter",
      where: "richmondwoodturners.org",
      subj: "About the Richmond Woodturners Newsletter",
      link: "Newsletter Editor",
    },
  ],
  [
    "competition",
    {
      who: "jimohanlon",
      where: "comcast.net",
      subj: "Richmond Woodturners Turning Competition",
      link: "Competition Chair",
    },
  ],
  [
    "donations",
    {
      who: "DanLuttrell",
      where: "verizon.net",
      subj: "Donations to Richmond Woodturners",
      link: "Dan Luttrell",
    },
  ],
  [
    "webmaster",
    {
      who: "webmaster",
      where: "richmondwoodturners.org",
      subj: "Richmond Woodturners Website Issue",
      link: "Webmaster",
    },
  ],
  [
    "women",
    {
      who: "pam.bozkurt",
      where: "richmondwoodturners.org",
      subj: "Women in Turning",
      link: "Women in Turning",
    },
  ],
]);

function createEmailLink(officer: string): HTMLAnchorElement | null {
  const config = officers.get(officer);
  if (config) {
    const anchor = document.createElement("a");
    anchor.href = `mailto:${config.who}@${config.where}?subject=${config.subj}&`;
    anchor.textContent = config.link;
    return anchor;
  } else {
    return null;
  }
}

export function fillOfficerEmails(): void {
  for (const officer of officers.keys()) {
    const anchorParents = document.getElementsByClassName(
      `officer-email-${officer}`,
    ) as HTMLCollectionOf<HTMLAnchorElement> | null;
    if (!anchorParents) continue;

    for (let i = 0; i < anchorParents.length; i++) {
      const parent = anchorParents[i];
      const emailLink = createEmailLink(officer);
      if (!emailLink) continue;
      parent.appendChild(emailLink);
    }
  }
}
